import React, { useState, useRef, useEffect } from 'react';

/**
 * useFormSecurity Hook
 * Gir usynlig beskyttelse mot botter og spam.
 */
const useFormSecurity = (formId = 'default') => {
  const [honeypotValue, setHoneypotValue] = useState('');
  const mountTime = useRef(Date.now());
  const MIN_SUBMISSION_TIME_MS = 2000;
  const STORAGE_KEY = `form_last_submit_${formId}`;
  const RATE_LIMIT_MS = 2000; // Redusert fra 10000 for bedre brukervennlighet

  const validateSubmission = () => {
    const now = Date.now();

    if (honeypotValue !== '') {
      console.warn('Security: Honeypot field filled.');
      return false;
    }

    const timeElapsed = now - mountTime.current;
    if (timeElapsed < MIN_SUBMISSION_TIME_MS) {
      console.warn(`Security: Form submitted too fast (${timeElapsed}ms).`);
      return false;
    }

    const lastSubmit = localStorage.getItem(STORAGE_KEY);
    if (lastSubmit) {
      const timeSinceLast = now - parseInt(lastSubmit, 10);
      if (timeSinceLast < RATE_LIMIT_MS) {
        alert('Vennligst vent litt før du sender inn på nytt.');
        return false;
      }
    }

    return true;
  };

  // Ny funksjon for å sette lock først når validering er OK
  const markAsSubmitted = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  };

  const HoneypotField = () => (
    <div
      style={{ opacity: 0, position: 'absolute', top: 0, left: 0, height: 0, width: 0, zIndex: -1, overflow: 'hidden' }}
      aria-hidden="true"
    >
      <label htmlFor={`${formId}_fax`}>Fax</label>
      <input
        type="text"
        id={`${formId}_fax`}
        name={`${formId}_fax`}
        tabIndex="-1"
        autoComplete="off"
        value={honeypotValue}
        onChange={(e) => setHoneypotValue(e.target.value)}
      />
    </div>
  );

  return { validateSubmission, markAsSubmitted, HoneypotField };
};

export default useFormSecurity;